import React, { Component } from 'react';
import {connect} from 'react-redux';
import { getSubQuestionList, softDeleteSubQuestion} from '../../actions/demographics';
import DemographicsSubQuestionList from '../../components/demographics/subQuestionList';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './style.css';

class DemographicsSubQuestions extends Component {
  constructor(props){
    super(props)
    this.queryString = window.location.href;

    if (this.queryString !== "") {
        this.catId = this.queryString.split('&c:')[1].split("/")[0];
        this.quesId = this.queryString.split('&q:')[1];
    }

    this.state={
      catId : this.catId,
      quesId : this.quesId,
      editOptionsData : '',
      editOptions: false
    };
      this.showAddSubQuestion = this.showAddSubQuestion.bind(this);
      this.softDeleteSubQuestion = this.softDeleteSubQuestion.bind(this);
      this.editSubQuestion = this.editSubQuestion.bind(this);
  }

  
  componentWillMount() {
    this.props.dispatch( getSubQuestionList( this.state.catId, this.state.quesId));
  }

  showAddSubQuestion(){
    this.props.history.push('/subQuestion/&c:'+this.state.catId+'/&q:' + this.state.quesId );
  }

  softDeleteSubQuestion(data){
    this.props.dispatch(softDeleteSubQuestion(data));
  }

  editSubQuestion(data){
    this.props.history.push('/editSubQuestion/&sq:'+data._id);
  }


  render(){
    let showDemographicsSubQuestionView = <DemographicsSubQuestionList
    demoGraphicsSubQuesOptionsListSuccess = {this.props.demoGraphicsSubQuesOptionsListSuccess}
    demoGraphicsSubQuesOptionsListData = {this.props.demoGraphicsSubQuesOptionsListData}
    showAddSubQuestion = {this.showAddSubQuestion}
    softDeleteSubQuestion ={this.softDeleteSubQuestion}
    editSubQuestion = {this.editSubQuestion}
    />
      
    return (
        <div> 
             {showDemographicsSubQuestionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsSubQuesOptionsListSuccess   :     state.demographics.demoGraphicsSubQuesOptionsListSuccess,
    demoGraphicsSubQuesOptionsListData      :     state.demographics.demoGraphicsSubQuesOptionsListData
  }
}

export default connect(mapStateToProps)(DemographicsSubQuestions);



// WEBPACK FOOTER //
// ./src/pages/demographics/demoSubquestion.js